import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../../components/Utils";
import {
  checkIfExist, pushItemsInSelectedFilters
} from "../../../components/UtilsForCart";


interface RouteInfo {
  locale: string
}
interface ComponentProps {
    subTaxonItem: any,
    pendingFilters: { index: string, values: string[] }[],
    setPendingFilters: React.Dispatch<React.SetStateAction<{ index: string, values: string[] }[]>>,
    isEndOfStock: boolean
}
const CheckboxFilter: React.FC<ComponentProps> = ({subTaxonItem, pendingFilters, setPendingFilters, isEndOfStock}: ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)
  let history = useNavigate();
  const [existInActiveFilters, setExistInActiveFilters] = useState(false)

  useEffect(() => {
      if(pendingFilters.length === 0){
        setExistInActiveFilters(false)
      }
    }, [pendingFilters]
  );

  const renderCheckbox = (subTaxonItem: any) => {
    const isChecked = pendingFilters.some(
      (filter: { index: any; values: string | any[]; }) =>
        filter.index === subTaxonItem.groupCode &&
        filter.values.includes(subTaxonItem.code)
    );

    return (
      <input
        className="form-check-input"
        type="checkbox"
        id={subTaxonItem.groupCode+subTaxonItem.code}
        checked={isChecked}
        onChange={() =>
          pushItemsInSelectedFilters(subTaxonItem, pendingFilters, setPendingFilters, history, isEndOfStock)
        }
      />
    );
  };


  return (
    subTaxonItem.extraData && subTaxonItem.extraData.firstColor ?
      <label className="checkbox-btn my-2">
        {renderCheckbox(subTaxonItem)}
        <span className="btn btn-light">
          <span className="color" style={{backgroundImage: `linear-gradient(180deg, ${subTaxonItem.extraData.firstColor}, ${subTaxonItem.extraData.secondColor ?? subTaxonItem.extraData.firstColor})`}}></span>
          {subTaxonItem.name}
        </span>
      </label>
      :
      <label className="form-check mb-2" key={subTaxonItem.groupCode+subTaxonItem.code+subTaxonItem.label} htmlFor={subTaxonItem.groupCode+subTaxonItem.code}>
        {renderCheckbox(subTaxonItem)}
        <span className="form-check-label"> { subTaxonItem.label } </span>
        {/*<b className="badge rounded-pill bg-dark float-end">120</b>*/}
      </label>
  )
}
export default CheckboxFilter;


